import { useQuery } from "@tanstack/react-query";
import { alertsApi } from "./client";

const keys = {
  all: ["alerts"] as const,
  summary: () => [...keys.all, "summary"] as const,
};

const REFETCH_MS = 5 * 60 * 1000;

export function useAlertsSummaryQuery() {
  return useQuery({
    queryKey: keys.summary(),
    queryFn: () => alertsApi.summary(),
    refetchInterval: REFETCH_MS,
    refetchOnWindowFocus: true,
  });
}
